<template>
    <div>
        <TheHeader class="mob-header" />
        <BaseTitle class="dsf" :infor="infor" />
        <div class="address">
            <div class="address-inner">
                <img class="address-ma" src="@/assets/images/contact_ma.png">
                <BaseAddress class="contactus-address" />
            </div>
        </div>
        <BaseTitleCenter class="contact-map-title" :title="infor.bottomTitle" />
        <div class="baidu-map" id="contactBDMap"></div>
        <TheFooter class="mob-the-footer-other" />
    </div>
</template>
<script>
    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseTitleCenter from '@/components/module/BaseTitleCenter'
    import BaseAddress from '@/components/module/BaseAddress'

    import '@/assets/less/module/module-base-address_contactus-address.less'

    export default {
        name: 'MobContactUs',
        props: {
            infor: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseAddress,
            BaseTitleCenter
        },
        mounted() {
            this.$parent.getBDMap();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-box {
    padding-bottom: .32rem;
}
/*导航*/
.address {
    width: 100%;
    padding-top: 1px;
    height: 6.24rem;
    background: #F0F4F6;
}
.address-inner {
    width: 100%;
}
.address-ma {
    margin: 1.4rem auto 0;
    width: 1.2rem;
    height: 1.2rem;
}
.title-h3 {
    padding: .532rem 0 .266rem;
    font-size: .373rem;
    font-weight: bold;
    text-align: center;
    font-weight: bold;
}
.contact-map-title {
    padding: .532rem 0 .266rem;
}
.baidu-map {
    width: 9.04rem;
    margin: 0 auto .533rem;
    height: 5.44rem;
    background: #F0F4F6;
}

</style>